















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import InjectionAuditService from "@/services/InjectionAuditService";
import moment from "moment";

@Component
export default class InjectionAuditChecklist extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  items: any[] = [];
  checks: { [itemId: number]: { item_definition_id: number; hasil: string | null; keterangan: string } } = {};

  loading = true;
  saving = false;

  aspekOrder = ["persiapan", "teknik_aseptik", "pasca_limbah", "high_alert"];
  aspekLabels: { [k: string]: string } = {
    persiapan: "I. Persiapan Sebelum Tindakan Injeksi",
    teknik_aseptik: "II. Teknik Aseptik Saat Tindakan",
    pasca_limbah: "III. Penanganan Pasca-Tindakan & Limbah",
    high_alert: "IV. Penggunaan Obat High Alert & NORUM"
  };

  totalYa = 0;
  totalTidak = 0;
  totalNa = 0;

  async created() {
    await Promise.all([this.loadSession(), this.loadItems()]);
    this.initChecks();
    this.recompute();
    this.loading = false;
  }

  async loadSession() {
    const res = await InjectionAuditService.find(this.sessionId);
    this.session = res.data.data;
  }

  async loadItems() {
    const res = await InjectionAuditService.getItemDefinitions();
    this.items = res.data.data || [];
  }

  initChecks() {
    // Seed checks dari existing item_checks
    const existing = (this.session.item_checks || []).reduce((acc: any, c: any) => {
      acc[c.item_definition_id] = c;
      return acc;
    }, {});

    this.items.forEach(item => {
      const existingCheck = existing[item.id];
      this.$set(this.checks, item.id, {
        item_definition_id: item.id,
        hasil: existingCheck ? existingCheck.hasil : null,
        keterangan: existingCheck ? existingCheck.keterangan || "" : ""
      });
    });
  }

  get itemsByAspek() {
    const grouped: { [k: string]: any[] } = {};
    this.items.forEach(item => {
      if (!grouped[item.aspek]) grouped[item.aspek] = [];
      grouped[item.aspek].push(item);
    });
    return grouped;
  }

  recompute() {
    let ya = 0, tidak = 0, na = 0;
    Object.values(this.checks).forEach(c => {
      if (c.hasil === "ya") ya++;
      else if (c.hasil === "tidak") tidak++;
      else if (c.hasil === "na") na++;
    });
    this.totalYa = ya;
    this.totalTidak = tidak;
    this.totalNa = na;
  }

  get totalBelum() {
    return Object.values(this.checks).filter(c => !c.hasil).length;
  }

  get liveCompliance() {
    const denom = this.totalYa + this.totalTidak;
    return denom > 0 ? (this.totalYa / denom) * 100 : 0;
  }

  get kategoriLabel() {
    if (this.liveCompliance >= 85) return "KEPATUHAN BAIK (≥85%)";
    if (this.liveCompliance >= 75) return "KEPATUHAN INTERMEDIATE (75-84%)";
    return "KEPATUHAN MINIMAL (<75%)";
  }

  get kategoriColor() {
    if (this.liveCompliance >= 85) return "green";
    if (this.liveCompliance >= 75) return "orange";
    return "red";
  }

  async saveDraft() {
    this.saving = true;
    try {
      // 1. Update session (temuan_utama, rekomendasi_tindak_lanjut)
      await InjectionAuditService.update(this.sessionId, this.session);

      // 2. Upsert checklist (hanya yang sudah ada jawaban)
      const checksToSave = Object.values(this.checks).filter(c => c.hasil);
      if (checksToSave.length > 0) {
        await InjectionAuditService.upsertChecks(this.sessionId, checksToSave);
      }
      this.$root.$emit("notify", { type: "success", message: "Draft tersimpan" });
    } catch (e) {
      // handled
    }
    this.saving = false;
  }

  async saveAndGoToDetail() {
    await this.saveDraft();
    this.$emit("submitted");
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }
}
